// 显示最合适的行数
function lineNumberForSingleListPage() {
    let h_client = document.documentElement.clientHeight
    let h_head = 64;
    let h_nav = 36;
    let h_search = 40;
    let h_tool = 34;
    let h_table_title = 30;
    let h_pagination = 36;
    let h_foot = 30;
    let h_space = 30; //富余空间
    
    //展示列表的区域高度
    let h_target = h_client - h_head - h_nav - h_search - h_tool - h_table_title - h_pagination - h_foot - h_space;

    //单行数据高度
    let h_data = 28;    

    //最适合展示的数据数（5的倍数）
    let count = parseInt(h_target / (h_data * 5)) * 5;

    //最少展示5行
    // return Math.max(count , 5);
    return 30
}

//页面只有一个列表时的高度
function tableHeight() {
    let h_client = document.documentElement.clientHeight
    let h_head = 64;
    let h_nav = 36;
    let h_search = 40;
    // let h_tool = 34;
    // let h_table_title = 30;
    // let h_pagination = 36;
    let h_foot = 30;
    let h_space = 50; //富余空间
    
    //展示列表的区域高度
    let h_target = h_client - h_head - h_nav - h_search - h_foot - h_space;

    return h_target;
}
//页面有上下两个列表时，顶部列表的高度
function topTableHeight() {
    return 290;
}
//页面有上下两个列表时，底部列表的高度
function bottomTableHeight() {
    let h_client = document.documentElement.clientHeight
    let h_head = 64;
    let h_nav = 36;
    let h_search = 40;
    let h_table1 = 300;
    let h_table2_sections = 50;
    // let h_pagination = 36;
    let h_foot = 30;
    let h_space = 50; //富余空间
    
    //展示列表的区域高度
    let h_target = h_client - h_head - h_nav - h_search - h_table1 - h_table2_sections - h_foot - h_space;

    return h_target;
}
//特殊页面使用（搜索项占位较多时）
function denseTableHeight() {
    let h_client = document.documentElement.clientHeight
    let h_head = 64;
    let h_nav = 36;
    let h_search = 40;
    // let h_tool = 34;
    // let h_table_title = 30;
    // let h_pagination = 36;
    let h_foot = 30;
    let h_space = 100; //富余空间
    
    //展示列表的区域高度
    let h_target = h_client - h_head - h_nav - h_search - h_foot - h_space;

    return h_target;
}

export {
    lineNumberForSingleListPage,
    tableHeight,
    topTableHeight,
    bottomTableHeight,
    denseTableHeight,
}